module.exports = __webpack_public_path__ + "static/media/standart_set.cf90ca71.png";